<template>
    <div>
        <template v-if="disabled && printMode">
            <span class="showText">{{showVal}}{{unit}}</span>
            <template v-if="upperCase && val !== ''">
                <span class="upper-case-box">
                    （{{digitUppercase(val)}}）
                </span>
            </template>
        </template>
        <template v-else>
            <el-input ref="input" :size="size" v-model="val" :placeholder="placeholder" @input="inputNum" @focus="focus" @blur="blurHandler()" @change="$emit('input', val);$emit('change', val)" :disabled="disabled" :readonly="readonly">
                <template v-if="unit && !appendUnit && !units.length" slot="prepend">{{unit}}</template>
                <template v-if="unit && appendUnit && !units.length" slot="append">{{unit}}</template>
                <el-select v-if="units.length" v-model="unitVal" @visible-change="visibleChange" @change="unitChange" slot="append" style="width: 65px;" :disabled="disabled || readonly" :size="size">
                    <el-option v-for="i in units" :key="i.value" :label="i.label" :value="i.value"></el-option>
                </el-select>
            </el-input>
            <div v-if="upperCase && val !== ''" class="upper-case-box">
                {{digitUppercase(val)}}
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'l-num',
        // props: ['placeholder', 'value', 'fix', 'unit', 'appendUnit', 'disabled', 'size'], // fix保留小数位
        props: {
            placeholder: {
                default: ''
            },
            value: {
                default: ''
            },
            fix: {
                default: ''
            },
            unit: {
                default: ''
            },
            appendUnit: {
                default: false
            },
            disabled: {
                default: false
            },
            printMode: {
                default: false
            },
            size: {
                default: ''
            },
            units: {
                default: () => {
                    return []
                }
            },
            readonly: {
                default: false
            },
            upperCase: {
                default: false // 是否显示金额大写
            },
            money: {
                default: false // 是否显示金额
            }
        },
        data() {
            return {
                val: '',
                unitVal: '',
                blurTimer: ''
            };
        },
        computed: {
            showVal() {
                if (this.money) return this.showMoney(this.val)
                return this.val
            }
        },
        watch: {
            value() {
                this.getVal()
            },
            unit () {
                this.unitVal = this.unit
            }
        },
        mounted() {
            this.getVal()
            this.unitVal = this.unit
        },
        methods: {
            getVal () {
                let res = this.value
                if ((this.disabled || this.readonly || this.printMode) && (!isNaN(res) || res === '')) {
                    res = (res*1).toFixed(this.fix*1)
                }
                this.val = res
            },
            digitUppercase(n) {
                var fraction = ['角', '分'];
                var digit = [
                    '零', '壹', '贰', '叁', '肆',
                    '伍', '陆', '柒', '捌', '玖'
                ];
                var unit = [
                    ['元', '万', '亿'],
                    ['', '拾', '佰', '仟']
                ];
                var head = n < 0 ? '欠' : '';
                n = Math.abs(n);
                var s = '';
                for (var i = 0; i < fraction.length; i++) {
                    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
                }
                s = s || '整';
                n = Math.floor(n);
                for (var i = 0; i < unit[0].length && n > 0; i++) {
                    var p = '';
                    for (var j = 0; j < unit[1].length && n > 0; j++) {
                        p = digit[n % 10] + unit[1][j] + p;
                        n = Math.floor(n / 10);
                    }
                    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
                }
                return head + s.replace(/(零.)*零元/, '元')
                    .replace(/(零.)+/g, '零')
                    .replace(/^整$/, '零元整');
            },
            blurHandler (now) {
                if (now) {
                    if (this.blurTimer) {
                        clearTimeout(this.blurTimer)
                        this.blurTimer = ''
                    }
                    return this.$emit('blur')
                }
                this.blurTimer = setTimeout(() => {
                    this.$emit('blur')
                }, 200)
                
            },
            visibleChange (bol) {
                if (bol) {
                    if (this.blurTimer) {
                        clearTimeout(this.blurTimer)
                        this.blurTimer = ''
                    }
                } else {
                    // this.blurHandler()
                    this.$refs.input.focus()
                }
            },
            unitChange () {
                this.$emit('update:unit', this.unitVal)
                this.$emit('unitChange', this.unitVal)
            },
            focus () {
                if (this.blurTimer) {
                    clearTimeout(this.blurTimer)
                    this.blurTimer = ''
                }
                console.log(this.blurTimer, 'this.blurTimer----')
                this.$refs.input.focus()
                this.$emit('focus')
            },
            blur () {
                this.$refs.input.blur()
            },
            each() {
                if (this.val == '-') {
                    return
                }
                if (isNaN(this.val)) {
                    this.val = this.val.substr(0, this.val.length - 1)
                    return this.each()
                }
                if (!this.val) return
                let str = String(this.val),
                    len = str.length,
                    start = str.indexOf('.')
                if (start < 0) return
                if (len - 1 - start > this.fix*1) {
                    this.val = this.val.substr(0, this.val.length - 1)
                    return this.each()
                }
            },
            inputNum() {
                if (!this.fix) {
                    this.val = this.val.replace(/[^0-9-]/ig, "")
                } else {
                    this.each()
                }
            },
        }
    }
</script>
<style scoped>

</style>